export default __webpack_public_path__ + "static/about-us-investor-relations-5172fdb22933a5a41254bfe49b5c169f.png";